import React from 'react'
import styles from './Header.module.css'

const header = () => {
  return (
    <header>
        <h1 className={styles.h1}>
            <a href="https://cellnology.jp" className={styles.link}>  {/* リンクを追加 */}
                <img src='/images/logo.png' alt='logo' className={styles.img}/>
            </a>
        </h1>
    </header>
  )
}

export default header